import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import Promise from 'bluebird';
import { injectIntl } from 'react-intl';
import { List, Map } from 'immutable';
import classNames from 'classnames';
import '../../vendor/mouseevent-polyfill';
import PanelTree from '../PanelTree';
import appConfig from '../../appConfig';
import { addError } from '../../actions/messageDialog';
import ToolIcon from '../Icons/Tool';
import AddSubCategoryIcon from '../Icons/AddSubCategoryDefault';
import CategoriesSmallIcon from '../Icons/CategoriesSmallDefault';
import ObjectCollectionsIcon from '../Icons/ObjectCollections';
import { updateCollectionIdBeingEdited } from '../../actions/mainUI';
import { setSelectedCategory } from '../../actions/umoGallery';

const mapDispatchToProps = (dispatch) => ({
  addError: (errMsg) => dispatch(addError(errMsg)),
  updateCollectionIdForEdit: (collectionId) =>
    dispatch(updateCollectionIdBeingEdited(collectionId)),
  setSelectedCategory: (category) => dispatch(setSelectedCategory(category)),
});

class PanelTreeItem extends Component {
  constructor(props) {
    super(props);

    // if true, this tree item is essentially used for categorisation and is not meant to be
    // interacted with
    const isHeaderType = this.props.type === 'CL' || this.props.type === 'CC';
    this.state = {
      isExpanded:
        props.isExpanded ||
        (props.isExpanded === undefined &&
          !appConfig.collapseCategories &&
          isHeaderType),
      isDragOver: false,
      isHeaderType,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onExpand = this.onExpand.bind(this);
  }

  componentDidMount() {
    document.addEventListener('onkeydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('onKeyDown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (e.metaKey || e.ctrlKey) {
      e.preventDefault();
    }
  }

  onClick(e) {
    e.preventDefault();
    this.props.setSelectedCategory(this.props.category);
    this.props.updateCollectionIdForEdit(this.props.collectionId);
    this.props.onPanelItemClick(
      this.props.id,
      this.props.name,
      this.props.description,
      this.props.search,
    );
  }

  onDrop(e) {
    this.setState({ isDragOver: false });
    if (this.props.canEdit) {
      this.props.onPanelItemDrop(e, this.props.id, false, this.props.canEdit);
    } else {
      this.props.addError(
        this.props.intl.formatMessage(
          { id: 'navCategoryPanel.noEditRoleError' },
          { catName: this.props.name },
        ),
      );
    }
  }

  onDragLeave(e) {
    e.preventDefault();
    this.setState({ isDragOver: false });
  }

  onDragOver(e) {
    e.preventDefault();
    this.setState({ isDragOver: true });
  }

  onExpand() {
    this.setState({ isExpanded: !this.state.isExpanded }, () => {
      if (this.state.isExpanded && !this.state.isHeaderType) {
        this.props.retrievePanelTreeList(this.props.id, this.props.type);
      } else if (!this.state.isHeaderType) {
        this.props.clearPanelTreeList(this.props.id);
      } else {
        this.props.toggleCollectionCollapse(this.props.id);
      }
    });
  }

  render() {
    const {
      customIcons,
      hideTreeIcon,
      id,
      name,
      description,
      search,
      colour,
      panelTreeList,
      onPanelItemClick,
      onPanelItemDrop,
      retrievePanelTreeList,
      retrieveChildrenRequests,
      clearPanelTreeList,
      toggleCollectionCollapse,
      canEdit,
      editRequests,
      onEditSelect,
      editOptions,
      showContentCount,
      contentCount,
      icon,
      collectionId,
      isRecycleBin,
    } = this.props;

    const hasChildren = this.state.isHeaderType
      ? panelTreeList.size > 0
      : this.props.hasChildren;

    // edit/wrench icon
    let edit = '';

    if (canEdit && !this.state.isHeaderType && onEditSelect && editOptions && !isRecycleBin) {
      edit = (
        <Dropdown
          className="btn-group"
          onSelect={(e, eKey) => {
            onEditSelect(e, id, name, description);
            this.props.updateCollectionIdForEdit(collectionId);
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown.Toggle
            className="dropdown-toggle"
            variant="link"
            size="xs"
            id="panel-tree-edit-dropdown"
          >
            <ToolIcon className="panel-item__option" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {editOptions.map((editData, i) => {
              if (!(editData.eventKey === 'upload' && this.props.type !== 'C'
                && this.props.type !== 'B')) {
                return (
                  <Dropdown.Item key={i} eventKey={editData.eventKey} value={editData.label}>
                    <span style={{ marginRight: 6 }}>{editData.icon}</span>
                    <span>{editData.label}</span>
                  </Dropdown.Item>
                );
              }
            })}
          </Dropdown.Menu>
        </Dropdown>
      );
    } else if (canEdit && onEditSelect && editOptions && editOptions.find(i => i.eventKey === 'subCategory')
      && this.props.type !== 'CC' && !isRecycleBin) {
      // for create collection category
      edit = (
        <Dropdown
          onSelect={(e, eKey) => {
            console.log(e);
            this.props.updateCollectionIdForEdit(collectionId);
            onEditSelect(e,this.state.isHeaderType ? '0' : id,name,this.state.isHeaderType ? id : null,description);
          }}
          className="btn-group"
          onClick={(e) => e.stopPropagation()}
        >
          <Dropdown.Toggle
            variant="link"
            size="xs"
            id="panel-tree-edit-dropdown"
          >
            <ToolIcon className="panel-item__option" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {editOptions.map((editData, i) => {
              if (editData.eventKey === 'subCategory') {
                return (
                  <Dropdown.Item key={i} eventKey={editData.eventKey}>
                    <AddSubCategoryIcon style={{ margin: '0 5px 3px 0' }} />
                    {this.props.intl.formatMessage({
                      id: 'navCategoryPanel.addCategoryButton',
                    })}
                  </Dropdown.Item>
                );
              }
            })}
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    // custom icons -- i.e. pin icon for workspace
    const customIconEls =
      !this.state.isHeaderType &&
      customIcons &&
      customIcons.map((iconData, i) => (
        <button
          key={i}
          onClick={() =>
            iconData.handler({
              workspaceID: id,
              workspaceName: name,
              workspaceDescription: description,
            })
          }
          className="panel-item__custom-icon"
        >
          {iconData.icon}
        </button>
      ));

    const isEditing =
      editRequests && editRequests.getIn([id, 'request']) instanceof Promise;

    if (editRequests && editRequests.getIn([id, 'request']) instanceof Error) {
      console.warn(editRequests.getIn([id, 'request']), editRequests.get(id));
    }

    let labelElement;
    let labelIcon = <i />;

    if (this.state.isHeaderType) {
      if (!hideTreeIcon) {
        labelIcon = (
          <ObjectCollectionsIcon style={{ margin: '0 6px' }} fill="#613D65" />
        );
      }

      labelElement = (
        <span className="panel-item__name--header">
          {labelIcon}
          {name}
        </span>
      );
    } else {
      if (!hideTreeIcon) {
        let color = colour || '613D65';
        if (color.toLowerCase() === 'ffffff') {
          color = '613D65';
        }
        labelIcon = (
          <CategoriesSmallIcon style={{ margin: '0 6px' }} fill={`#${color}`} />
        );
      }

      if (icon) {
        labelIcon = icon;
      }

      labelElement = (
        <a
          className={classNames('panel-item__name', {
            'panel-item__name--is-drag-over': this.state.isDragOver,
          })}
          id={id}
          href={null}
          onClick={this.onClick}
          data-name={name}
          data-editable={this.props.canEdit}
        >
          {labelIcon}
          {isEditing ? editRequests.getIn([id, 'workspaceName']) : name}
        </a>
      );
    }

    let count = '';
    if (showContentCount && search) {
      count = (
        <span className="panel-item__count">
          <i />
        </span>
      );
    } else if (showContentCount && contentCount && contentCount !== '0') {
      count = <span className="panel-item__count">{contentCount}</span>;
    }

    return (
      <div
        className={classNames('panel-item', {
          'panel-item--no-children': !hasChildren,
        })}
      >
        <div
          className={classNames('panel-item__link', {
            'panel-item__link--is-editing': isEditing,
            'panel-item__link--is-drag-over': this.state.isDragOver,
          })}
          onDrop={
            !this.state.isHeaderType && this.props.onPanelItemDrop
              ? this.onDrop
              : undefined
          }
          onDragOver={
            !this.state.isHeaderType && this.props.onPanelItemDrop
              ? this.onDragOver
              : undefined
          }
          onDragLeave={
            !this.state.isHeaderType && this.props.onPanelItemDrop
              ? this.onDragLeave
              : undefined
          }
          onClick={() => this.state.isHeaderType && this.onExpand()}
        >
          {labelElement}
          {count}
          {edit}
          {customIconEls}
        </div>

        {hasChildren && (
          <i
            className={classNames('panel-item__icon', {
              'panel-item__icon--expanded':
                this.state.isExpanded && !retrieveChildrenRequests.get(id),
              'panel-item__icon--collapsed':
                !this.state.isExpanded && !retrieveChildrenRequests.get(id),
              'panel-item__icon--loading':
                retrieveChildrenRequests.get(id) &&
                !(retrieveChildrenRequests.get(id) instanceof Error),
              'panel-item__icon--error':
                retrieveChildrenRequests.get(id) &&
                retrieveChildrenRequests.get(id) instanceof Error,
            })}
            onClick={this.onExpand}
          />
        )}
        {this.state.isExpanded && (
          <div className="panel-item__children">
            <PanelTree
              retrievePanelTreeList={retrievePanelTreeList}
              retrieveChildrenRequests={retrieveChildrenRequests}
              clearPanelTreeList={clearPanelTreeList}
              toggleCollectionCollapse={toggleCollectionCollapse}
              onPanelItemClick={onPanelItemClick}
              onPanelItemDrop={onPanelItemDrop}
              panelTreeList={panelTreeList}
              editRequests={editRequests}
              customIcons={customIcons}
              onEditSelect={onEditSelect}
              editOptions={editOptions}
              showContentCount={showContentCount}
              contentCount={contentCount}
              icon={icon}
            />
          </div>
        )}
      </div>
    );
  }
}

PanelTreeItem.propTypes = {
  customIcons: PropTypes.arrayOf(
    PropTypes.shape({
      iconClass: PropTypes.string,
      handler: PropTypes.func,
    })
  ),
  category: PropTypes.instanceOf(Map),
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
  search: PropTypes.string,
  colour: PropTypes.string,
  hasChildren: PropTypes.bool,
  panelTreeList: PropTypes.instanceOf(List),
  onPanelItemClick: PropTypes.func,
  onPanelItemDrop: PropTypes.func,
  retrievePanelTreeList: PropTypes.func,
  retrieveChildrenRequests: PropTypes.shape({}),
  clearPanelTreeList: PropTypes.func,
  toggleCollectionCollapse: PropTypes.func,
  canEdit: PropTypes.bool,
  editRequests: PropTypes.shape({}),
  onEditSelect: PropTypes.func,
  showContentCount: PropTypes.bool,
  contentCount: PropTypes.string,
  editOptions: PropTypes.arrayOf(
    PropTypes.shape({
      eventKey: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  addError: PropTypes.func,
  isExpanded: PropTypes.bool,
  icon: PropTypes.instanceOf(Object),
  isRecycleBin: PropTypes.bool,
};

export default injectIntl(connect(null, mapDispatchToProps)(PanelTreeItem));
